module.exports = __webpack_public_path__ + "static/Forecast1-1ef00393d5526b7ae52b1dc2d62f187b.png";